export const PLAN_TIERS = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  ENTERPRISE: 'enterprise'
};

export const getPlanPermissions = (planTier) => {
  const tier = planTier?.toLowerCase() || PLAN_TIERS.BASIC;
  
  return {
    logo: tier !== PLAN_TIERS.BASIC,
    stampin: {
      draggable: tier !== PLAN_TIERS.BASIC,
      resizable: tier === PLAN_TIERS.ENTERPRISE
    },
    all: tier === PLAN_TIERS.ENTERPRISE,
  };
};
